module.exports = __webpack_public_path__ + "img/sankaku_26_blue.85541860.png";